import { Box, Heading, VStack, Text,Image,SimpleGrid,useColorModeValue , useBreakpointValue,useToast,
FormControl,
FormLabel,
Grid,
Input,
InputGroup,
InputRightElement,
Select,
Flex,
Checkbox,
HStack,
} from '@chakra-ui/react';
import { useDisclosure } from "@chakra-ui/react";
import PublicLayout from "./Layouts/PublicLayout";
import { useState,useRef,  } from "react";
import { useNavigate, } from "react-router-dom";
import { useEffect, } from 'react';

import { useLocation } from 'react-router-dom'; 
import {  OfferDetails } from '../../Platform/Common/types';
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  Button,
  Divider,
} from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import bandpic from "../../resources/EDUVIC B2C Hero3.png";
import { FaLock, FaCheckCircle } from "react-icons/fa";
import { Link, Icon } from "@chakra-ui/react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
  ModalBody, ModalFooter,
} from "@chakra-ui/react";
import ReCAPTCHA from "react-google-recaptcha";
// and add useRef to your existing "react" import

interface B2CCheckoutPageProps {
onLogin: (token: string , refresh_token:string) => void;
}


const B2CCheckoutPage: React.FC<B2CCheckoutPageProps> = ({
  onLogin
}) => {

  const { domainSlug } = useParams<{ domainSlug?: string }>();
  const { offerSlug } = useParams<{ offerSlug?: string }>();
  const recaptchaRef = useRef<ReCAPTCHA>(null);
const [captchaToken, setCaptchaToken] = useState<string | null>(null);
const recaptchaKey = process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;

type OverlapProduct = {
  product_id: number;
  product_name: string;
  end_date?: string | null;
};

const [overlapProducts, setOverlapProducts] = useState<OverlapProduct[]>([]);
const {
  isOpen: isOverlapModalOpen,
  onOpen: onOverlapModalOpen,
  onClose: onOverlapModalClose,
} = useDisclosure();

  const token = localStorage.getItem("token");

  const navigate = useNavigate();

  const theme = useColorModeValue("light", "dark");
  const isMobile = useBreakpointValue({ base: true, md: false });

  const toast = useToast();

  const { hash, pathname } = useLocation();

    const location = useLocation();


  // =========================
  // OFFER
  // =========================

  const [offerDetails, setOfferDetails] = useState<OfferDetails>();

  const summaryBg = useColorModeValue("gray.50", "gray.700");
const secureBg = useColorModeValue("blue.50", "blue.900");
const secureText = useColorModeValue("blue.700", "blue.200");
const freeBg = useColorModeValue("green.50", "green.900");
const freeBorder = useColorModeValue("green.200", "green.700");
const mutedText = useColorModeValue("gray.300", "gray.500");

 const apiUrl = process.env.REACT_APP_API_URL || "https://default-url.com";
 const GST_REGISTERED =
  process.env.REACT_APP_GST_REGISTERED === "true";

 // =========================
 // COUNTRY-SPECIFIC VALIDATION RULES
 // =========================
 // One instance is spun up per geography (see REACT_APP_PLATFORM_COUNTRY,
 // mirrors backend PLATFORM_COUNTRY). Add a new entry here when a new
 // instance targets a different country -- nothing else in this file
 // should need to change.
 const PLATFORM_COUNTRY = process.env.REACT_APP_PLATFORM_COUNTRY || "AU";

 type CountryValidationRules = {
   countryName: string;
   postcodeRegex: RegExp;
   postcodeHint: string;
   phoneRegex: RegExp;
   phoneHint: string;
   states: string[];
 };

 const COUNTRY_VALIDATION_RULES: Record<string, CountryValidationRules> = {
   AU: {
     countryName: "Australia",
     postcodeRegex: /^\d{4}$/,
     postcodeHint: "Please enter a valid 4-digit postcode",
     // Australian mobile/landline: optional +61 or 0 prefix, then 9 digits
     phoneRegex: /^(?:\+?61|0)[2-478]\d{8}$/,
     phoneHint: "Please enter a valid Australian phone number",
     states: [
       "Victoria",
       "New South Wales",
       "Queensland",
       "Western Australia",
       "South Australia",
       "Tasmania",
       "Australian Capital Territory",
       "Northern Territory",
     ],
   },
   // Add the next geography here, e.g.:
   // US: {
   //   countryName: "United States",
   //   postcodeRegex: /^\d{5}(-\d{4})?$/,
   //   postcodeHint: "Please enter a valid ZIP code",
   //   phoneRegex: /^(?:\+?1)?\d{10}$/,
   //   phoneHint: "Please enter a valid US phone number",
   //   states: [ /* ... */ ],
   // },
 };

 // Falls back to AU rules if an unrecognized country code is deployed,
 // rather than silently disabling validation.
 const countryRules = COUNTRY_VALIDATION_RULES[PLATFORM_COUNTRY] || COUNTRY_VALIDATION_RULES.AU;



useEffect(() => {
  let cancelled = false;

  const fetchOfferDetails = async () => {
    if (!domainSlug || !offerSlug) return;
    try {
      const response = await axios.get(`${apiUrl}/b2c/public/domain/${domainSlug}/offer/${offerSlug}`);
      if (!cancelled) setOfferDetails(response.data);
    } catch (error) {
      if (!cancelled) {
        console.error("Failed to load B2C Offer", error);
        toast({ title: "Unable to load offer", status: "error", duration: 3000, isClosable: true });
      }
    }
  };

  fetchOfferDetails();
  return () => { cancelled = true; };
}, [domainSlug, offerSlug, apiUrl, toast]);
  // =========================
  // SCROLL RESET
  // =========================

  useEffect(() => {

    if (hash) {

      const element = document.querySelector(hash);

      if (element) {

        const yOffset = -80;

        const yPosition =
          element.getBoundingClientRect().top +
          window.scrollY +
          yOffset;

        window.scrollTo({
          top: yPosition,
          behavior: "smooth",
        });

        return;
      }
    }

    window.scrollTo(0, 0);

  }, [pathname, hash]);

  // =========================
  // FORM STATE
  // =========================

  const [showPassword, setShowPassword] = useState(false);

  const [acceptTerms, setAcceptTerms] = useState(false);

  //const [isAuthenticated, setIsAuthenticated] = useState(false);
/*   const isAuthenticated =
  !!localStorage.getItem("b2c_token"); */

  const [isAuthenticated, setIsAuthenticated] =
  useState(false);

    useEffect(() => {

    const token =
        localStorage.getItem("b2c_token");

    setIsAuthenticated(!!token);

    }, []);

  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    contact_no: "",
    street_address: "",
    suburb: "",
    postcode: "",
    state: "",
    country: countryRules.countryName,
  });


  // =========================
  // THEME
  // =========================

  const resolvedTheme =
    (offerDetails?.theme_key || "BLUE").toLowerCase();

  const resolvedBadgeTheme =
    (offerDetails?.badge_theme || "gray").toLowerCase();

  const heroBg = useColorModeValue(
    `${resolvedTheme}.50`,
    `${resolvedTheme}.900`
  );

  const heroTextColor = useColorModeValue(
    "gray.800",
    "white"
  );

  const badgeBg = useColorModeValue(
    `${resolvedBadgeTheme}.200`,
    `${resolvedBadgeTheme}.700`
  );

  const badgeText = useColorModeValue(
    `${resolvedBadgeTheme}.800`,
    "white"
  );

  const borderColor = useColorModeValue(
    `${resolvedTheme}.300`,
    `${resolvedTheme}.500`
  );

  const cardBg = useColorModeValue(
    "white",
    "gray.800"
  );

  const subtleBg = useColorModeValue(
    "gray.50",
    "gray.900"
  );

  const durationBg = useColorModeValue(
    "gray.100",
    "gray.700"
  );

  const noticeBg = useColorModeValue(
    "orange.50",
    "orange.900"
  );

  const paymentBg = useColorModeValue(
    "gray.50",
    "gray.700"
  );

  const inputBg = useColorModeValue(
    "white",
    "gray.800"
  );

   const [couponCode, setCouponCode] = useState("");
const [couponResult, setCouponResult] = useState<{
  valid: boolean;
  discount_amount?: number;
  final_amount?: number;
  message?: string;
} | null>(null);
const [couponLoading, setCouponLoading] = useState(false);

const handleApplyCoupon = async () => {
  if (!couponCode.trim() || !offerDetails) return;

  let accessToken = localStorage.getItem("b2c_token");
  if (!accessToken) {
    toast({ title: "Please register or log in first to apply a coupon", status: "warning", duration: 3000 });
    return;
  }

  setCouponLoading(true);
  try {
    const { data } = await axios.post(
      `${apiUrl}/b2c/coupon/validate`,
      { coupon_code: couponCode.trim(), offer_id: offerDetails.offer_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    setCouponResult(data);
    if (!data.valid) {
      toast({ title: data.message, status: "warning", duration: 3000 });
    }
  } catch (error: any) {
    toast({ title: error?.response?.data?.detail || "Failed to validate coupon", status: "error", duration: 3000 });
  } finally {
    setCouponLoading(false);
  }
};


  // =========================
  // FLAGS
  // =========================

  const isFreeOffer =
    Number(offerDetails?.total_price || 0) === 0;

  const isHero =
    offerDetails?.promotion_tier === "HERO";

  const payButtonLabel = isFreeOffer
    ? (isAuthenticated ? "Activate Free Access" : "Activate & Register")
    : `Pay${isAuthenticated ? "" : " & Register"} ${offerDetails?.currency ?? ""} ${(couponResult?.valid
        ? (couponResult.final_amount ?? Number(offerDetails?.total_price ?? 0))
        : Number(offerDetails?.total_price ?? 0)
      ).toFixed(2)}`;

  const payButtonLoadingText = isFreeOffer
    ? "Activating..."
    : (isAuthenticated ? "Redirecting to payment..." : "Registering & redirecting to payment...");

  // =========================
  // HANDLERS
  // =========================
  // =========================
  // VALIDATION
  // =========================

  const COMMON_PASSWORDS = new Set([
  "password", "password1", "password123", "12345678", "123456789",
  "1234567890", "qwerty123", "qwertyuiop", "iloveyou", "11111111",
  "00000000", "abc12345", "letmein1", "welcome1", "football1",
]);

  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Mirrors exactly the fields marked isRequired in the Account Registration
  // form. Used as a hard gate before EITHER registration path (Pay & Register
  // or the standalone Register button) is allowed to hit the API -- prevents
  // blank/garbage accounts from being created, which previously slipped
  // through and only surfaced later as an opaque Stripe failure.
  const validateRegistrationForm = (): boolean => {
    if (!formData.first_name.trim()) {
      toast({ title: "Please enter your first name", status: "warning", duration: 3000, isClosable: true });
      return false;
    }
    if (!formData.email.trim() || !EMAIL_REGEX.test(formData.email.trim())) {
      toast({ title: "Please enter a valid email address", status: "warning", duration: 3000, isClosable: true });
      return false;
    }
    if (!countryRules.phoneRegex.test(formData.contact_no.trim())) {
      toast({ title: countryRules.phoneHint, status: "warning", duration: 3000, isClosable: true });
      return false;
    }
    if (!formData.password || formData.password.length < 8) {
      toast({ title: "Password must be at least 8 characters", status: "warning", duration: 3000, isClosable: true });
      return false;
    }
    // in validateRegistrationForm, after the length check:
    if (COMMON_PASSWORDS.has(formData.password.toLowerCase())) {
      toast({ title: "That password is too common. Please choose another.", status: "warning", duration: 3000, isClosable: true });
      return false;
    }
    if (!formData.street_address.trim()) {
      toast({ title: "Please enter your street address", status: "warning", duration: 3000, isClosable: true });
      return false;
    }
    if (!formData.suburb.trim()) {
      toast({ title: "Please enter your suburb", status: "warning", duration: 3000, isClosable: true });
      return false;
    }
   if (!countryRules.postcodeRegex.test(formData.postcode.trim())) {
      toast({ title: countryRules.postcodeHint, status: "warning", duration: 3000, isClosable: true });
      return false;
    }
    if (!formData.state) {
      toast({ title: "Please select your state", status: "warning", duration: 3000, isClosable: true });
      return false;
    }
    return true;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



const proceedToCheckout = async (accessToken: string) => {
  const sessionResponse = await axios.post(
    `${apiUrl}/b2c/stripe/create-checkout-session`,
    {
      offer_id: offerDetails?.offer_id,
      success_url: `${window.location.origin}/practice/payment-success?session_id={CHECKOUT_SESSION_ID}`,
      cancel_url: `${window.location.origin}/practice/${domainSlug}/${offerSlug}/checkout?offer=${offerDetails?.offer_id}`,
      coupon_code: couponResult?.valid ? couponCode.trim() : undefined,
    },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  window.location.href = sessionResponse.data.checkout_url;
};

const registerAccount = async () => {
  if (!captchaToken) {
    toast({
      title: "Please complete the verification in the Account Registration section",
      status: "warning", duration: 4000, isClosable: true,
    });
    return null;
  }
  try {
    return await axios.post(`${apiUrl}/public/b2c/student-registration`, {
      ...formData,
      recaptcha_token: captchaToken,
    });
  } finally {
    // single use, so reset whether registration succeeded or failed
    recaptchaRef.current?.reset();
    setCaptchaToken(null);
  }
};

const handleBuyNow = async () => {
  if (checkoutLoading || registerLoading) return; // block concurrent submits from either action

  if (!acceptTerms) {
    toast({ title: "Please accept terms and conditions", status: "warning", duration: 3000, isClosable: true });
    return;
  }

  // ── Get or create token ──────────────────────────────────────
  let accessToken = localStorage.getItem("b2c_token");
  let refreshToken = localStorage.getItem("b2c_refresh_token");

  // Only validate the form when we're actually about to register with it --
  // an already-authenticated user has no formData to validate here.
  if (!accessToken && !validateRegistrationForm()) {
    return;
  }

  try {
    setCheckoutLoading(true);


    if (!accessToken) {
      const registrationResponse = await registerAccount();
      if (!registrationResponse) return;   // captcha not completed
      accessToken = registrationResponse.data.access_token;
      refreshToken = registrationResponse.data.refresh_token;

      if (accessToken && refreshToken) {
        // onLogin is responsible for persisting BOTH tokens to localStorage
        // and updating router-level auth state -- do not set localStorage
        // directly here, to avoid two places writing the same keys.
        onLogin(accessToken, refreshToken);
      }
    }

    if (!accessToken) {
      // Registration silently failed to return a token -- don't proceed
      // into a purchase call with a null Authorization header.
      toast({ title: "Registration failed. Please try again.", status: "error", duration: 4000, isClosable: true });
      return;
    }

    // ── Free offer flow ──────────────────────────────────────────
    if (isFreeOffer) {
      await axios.put(
        `${apiUrl}/b2c/purchase-free-offer/${offerDetails?.offer_id}`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      toast({
        title: "Purchase successful",
        description: "Your free offer has been activated successfully.",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      navigate("/practice/app");
      return;
    }

    // ── Paid offer flow -- check overlap before creating checkout session ──
    const { data: overlap } = await axios.get(
      `${apiUrl}/b2c/offer/${offerDetails?.offer_id}/overlap-check`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    if (overlap.has_overlap) {
      setOverlapProducts(overlap.overlapping_products);
      onOverlapModalOpen();
      return; // wait for user's explicit "Continue anyway" click
    }

    await proceedToCheckout(accessToken);

  } catch (error: any) {
    console.error(error);
    const errorMessage = error?.response?.data?.detail || "Checkout failed";
    toast({ title: errorMessage, status: "error", duration: 4000, isClosable: true });
  } finally {
    setCheckoutLoading(false);
  }
};

const handleRegisterOnly = async () => {
  if (registerLoading || checkoutLoading) return; // block concurrent submits from either action

  if (!validateRegistrationForm()) {
    return;
  }

  setRegisterLoading(true);

  try {
    const registrationResponse = await registerAccount();
    if (!registrationResponse) return;


    // Mirror handleBuyNow exactly: don't require refresh_token to consider
    // this a success, and only call onLogin if both happen to be present.
    const accessToken = registrationResponse.data.access_token;
    const refreshToken = registrationResponse.data.refresh_token;

    if (accessToken && refreshToken) {
      onLogin(accessToken, refreshToken);
    }

    if (!accessToken) {
      toast({ title: "Registration failed. Please try again.", status: "error", duration: 4000, isClosable: true });
      return;
    }

    setIsAuthenticated(true);
    toast({
      title: "Registration successful",
      description: "You're now logged in — apply your coupon or continue to payment whenever you're ready.",
      status: "success",
      duration: 4000,
      isClosable: true,
    });

  } catch (error: any) {
    console.error(error);
    const errorMessage = error?.response?.data?.detail || "Registration failed";
    toast({ title: errorMessage, status: "error", duration: 4000, isClosable: true });
  } finally {
    setRegisterLoading(false);
  }
};

const handleContinueDespiteOverlap = async () => {
  onOverlapModalClose();
  try {
    setCheckoutLoading(true);
    const accessToken = localStorage.getItem("b2c_token");
    if (!accessToken) {
      toast({ title: "Session expired. Please try again.", status: "error", duration: 4000, isClosable: true });
      return;
    }
    await proceedToCheckout(accessToken);
  } catch (error: any) {
    console.error(error);
    const errorMessage = error?.response?.data?.detail || "Checkout failed";
    toast({ title: errorMessage, status: "error", duration: 4000, isClosable: true });
  } finally {
    setCheckoutLoading(false);
  }
};
  

// =========================
// HERO OVERLAY
// =========================

const heroOverlay = useColorModeValue(
  `linear(to-r,
    rgba(255,255,255,0.88),
    rgba(255,255,255,0.72)
  )`,
  `linear(to-r,
    rgba(17,24,39,0.82),
    rgba(17,24,39,0.72)
  )`
);

// Theme tint layer
const heroThemeTint = useColorModeValue(
  `${resolvedTheme}.50`,
  `${resolvedTheme}.900`
);


  const overlapBg = useColorModeValue(
    "gray.50",
    "gray.700"
  );


  return (

    <PublicLayout>

      <Box bg={subtleBg} minH="calc(80vh - 72px)">

      {/* ================= Hero ================= */}

      <Box
        as="section"
        minH={{ base: "260px", md: "320px" }}
        bgImage={bandpic}
        bgSize="cover"
        // Mobile crops from the left side of the source image instead of
        // the right, so the logo/figure moves out of the text's way.
        // Desktop/tablet unchanged.
        bgPosition={{ base: "left center", md: "right center" }}
        bgRepeat="no-repeat"
        position="relative"
        overflow="hidden"
      >
        {/* LEFT Gradient Overlay for readability */}
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          bgGradient="
            linear(
              to-r,
              rgba(0,0,0,0.68),
              rgba(0,0,0,0.35),
              rgba(0,0,0,0)
            )
          "
          zIndex={1}
        />

        {/* Content */}
        <Box
          position="relative"
          zIndex={2}
          minH={{ base: "260px", md: "320px" }}
          display="flex"
          alignItems="center"
          px={{ base: 6, md: 16 }}
        >
          <VStack
            align="flex-start"
            spacing={4}
            maxW="700px"
          >

            <Heading
              color="white"
              size="2xl"
              lineHeight="1.2"
            >
              Checkout
            </Heading>

            {offerDetails?.name && (
              <Heading
                size="xl"
                color="white"
                fontWeight="bold"
                lineHeight="1.3"
              >
                {offerDetails.name}
              </Heading>
            )}

            {offerDetails?.duration_label && (
              <Text
                fontSize={{ base: "md", md: "lg" }}
                color="gray.100"
                fontWeight="bold"
                lineHeight="1.5"
              >
                {offerDetails.duration_label}
              </Text>
            )}

          </VStack>
        </Box>
      </Box>

        {/* ================= NOTICE ================= */}

        <Box px={6} pt={8}>

          <Box
            maxW="1200px"
            mx="auto"
            bg={noticeBg}
            border="1px solid"
            borderColor="orange.300"
            rounded="xl"
            p={6}
          >

            <VStack align="start" spacing={3}>

              <Text fontWeight="bold">
                Returning customer?{" "}
                <Text
                  as="span"
                  color="blue.500"
                  cursor="pointer"
                  textDecoration="underline"
                  onClick={() => {navigate("/practice/login", {
                                    state: {
                                        from: location.pathname
                                    }
                                    });}}
                >
                  Click here to login
                </Text>
              </Text>

              <Text>
                ❗ Create a separate account for each student; only one active session per user is allowed.
              </Text>

              <Text>
                ✅ Register using a valid email address.
              </Text>

              <Text>
                ✅ This email address is essential for receiving practice test reports and important account-related notifications.
              </Text>

              <Text>
                ✅ Credit Card Payments (Stripe): We accept Visa, Mastercard, and American Express (AMEX).
              </Text>

            </VStack>

          </Box>

        </Box>

        {/* ================= MAIN ================= */}

        <Box py={8} px={6}>

          <Grid
            templateColumns={{ base: "1fr", lg: "1.2fr 0.8fr" }}
            gap={8}
            maxW="1200px"
            mx="auto"
            alignItems="start"
          >

            {/* ================================================= */}
            {/* LEFT */}
            {/* ================================================= */}

            <Box>

              {!isAuthenticated ? (

                <Box
                  bg={cardBg}
                  rounded="2xl"
                  border="1px solid"
                  borderColor={borderColor}
                  overflow="hidden"
                >

                  <Box
                    height="6px"
                    bg={`${resolvedTheme}.500`}
                  />

                  <Box p={8}>

                    <Heading size="lg" mb={8}>
                      Account Registration
                    </Heading>

                    <VStack spacing={5} align="stretch">

                      <SimpleGrid
                        columns={{ base: 1, md: 2 }}
                        spacing={5}
                      >

                        <FormControl isRequired>
                          <FormLabel>First Name</FormLabel>
                          <Input
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleInputChange}
                            bg={inputBg}
                          />
                        </FormControl>

                        <FormControl>
                          <FormLabel>Last Name</FormLabel>
                          <Input
                            name="last_name"
                            value={formData.last_name}
                            onChange={handleInputChange}
                            bg={inputBg}
                          />
                        </FormControl>

                      </SimpleGrid>

                      <SimpleGrid
                        columns={{ base: 1, md: 2 }}
                        spacing={5}
                      >

                        <FormControl isRequired>
                          <FormLabel>Email Address</FormLabel>
                            <Input
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleInputChange}
                              bg={inputBg}
                              autoComplete="email"
                              autoCapitalize="none"
                              autoCorrect="off"
                              spellCheck={false}
                            />
                        </FormControl>

                        <FormControl isRequired>
                          <FormLabel>Contact Number</FormLabel>
                          <Input
                            name="contact_no"
                            value={formData.contact_no}
                            onChange={handleInputChange}
                            bg={inputBg}
                          />
                        </FormControl>

                      </SimpleGrid>

                      <FormControl isRequired>
                        <FormLabel>Password</FormLabel>

                        <InputGroup>

                          <Input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            bg={inputBg}
                            autoComplete="new-password"
                            autoCapitalize="none"
                            autoCorrect="off"
                            spellCheck={false}
                          />

                          <InputRightElement width="4.5rem">

                            <Button
                              h="1.75rem"
                              size="sm"
                              onClick={() =>
                                setShowPassword(!showPassword)
                              }
                            >
                              {showPassword ? "Hide" : "Show"}
                            </Button>

                          </InputRightElement>

                        </InputGroup>

                      </FormControl>

                      <Divider py={2} />

                      <Heading size="md">
                        Billing Details
                      </Heading>

                      <FormControl isRequired>
                        <FormLabel>Street Address</FormLabel>

                        <Input
                          name="street_address"
                          value={formData.street_address}
                          onChange={handleInputChange}
                          bg={inputBg}
                        />

                      </FormControl>

                      <SimpleGrid
                        columns={{ base: 1, md: 2 }}
                        spacing={5}
                      >

                        <FormControl isRequired>
                          <FormLabel>Suburb</FormLabel>

                          <Input
                            name="suburb"
                            value={formData.suburb}
                            onChange={handleInputChange}
                            bg={inputBg}
                          />

                        </FormControl>

                        <FormControl isRequired>
                          <FormLabel>Postcode</FormLabel>

                          <Input
                            name="postcode"
                            value={formData.postcode}
                            onChange={handleInputChange}
                            bg={inputBg}
                          />

                        </FormControl>

                      </SimpleGrid>

                      <SimpleGrid
                        columns={{ base: 1, md: 2 }}
                        spacing={5}
                      >

                        <FormControl isRequired>
                          <FormLabel>State</FormLabel>

                          <Select
                            name="state"
                            value={formData.state}
                            onChange={handleInputChange}
                            bg={inputBg}
                          >
                            <option value="">
                              Select State
                            </option>

                            {countryRules.states.map((state) => (
                              <option
                                key={state}
                                value={state}
                              >
                                {state}
                              </option>
                            ))}

                          </Select>

                        </FormControl>

                        <FormControl isRequired>
                          <FormLabel>Country</FormLabel>

                          <Input
                            value={formData.country}
                            isReadOnly
                            bg={inputBg}
                          />

                        </FormControl>

                      </SimpleGrid>

                    </VStack>

                    <Divider my={6} />

                    <VStack align="stretch" spacing={3}>

                      {recaptchaKey && (
                      <Box display="flex" justifyContent="center">
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={recaptchaKey}
                          onChange={(t) => setCaptchaToken(t)}
                          onExpired={() => setCaptchaToken(null)}
                        />
                      </Box>
                    )}

                    {!isFreeOffer && (
                      <>
                      <Button
                        variant="outline"
                        colorScheme={resolvedTheme}
                        size="md"
                        isLoading={registerLoading}
                        isDisabled={checkoutLoading}
                        loadingText="Registering..."
                        onClick={handleRegisterOnly}
                      >
                        Register
                      </Button>

                      <Text fontSize="sm" fontWeight="medium" color={`${resolvedTheme}.600`}>
                        Have a coupon? Register first to apply it. No coupon? Just use "Pay &amp; Register" in Payment section.
                      </Text>
                      </>
                    )}
                    </VStack>

                  </Box>

                </Box>

              ) : (

                <Box
                  bg={cardBg}
                  rounded="2xl"
                  border="1px solid"
                  borderColor={borderColor}
                  p={8}
                >

                  <Heading size="md" mb={3}>
                    Logged In
                  </Heading>

                  <Text>
                    You are logged in and can continue with checkout.
                  </Text>

                </Box>

              )}

            </Box>

            <Modal isOpen={isOverlapModalOpen} onClose={onOverlapModalClose} isCentered>
                      <ModalOverlay />
                      <ModalContent mx={4}>
                        <ModalHeader>You already have access to some of this content</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                          <Text mb={3}>
                            This offer includes the following, which you already have active access to:
                          </Text>
                          <VStack align="stretch" spacing={2} mb={3}>
                            {overlapProducts.map((product) => (
                              <Box
                                key={product.product_id}
                                p={3}
                                bg={overlapBg}
                                borderRadius="md"
                                fontSize="sm"
                              >
                                <Text fontWeight="medium">{product.product_name}</Text>
                                {product.end_date && (
                                  <Text fontSize="xs" color="gray.500">
                                    Active until {new Date(product.end_date).toLocaleDateString()}
                                  </Text>
                                )}
                              </Box>
                            ))}
                          </VStack>
                          <Text fontSize="sm" color="gray.500">
                            You can still go ahead if you'd like the rest of this bundle — your existing
                            access won't be affected either way.
                          </Text>
                        </ModalBody>
                        <ModalFooter gap={3}>
                          <Button variant="ghost" onClick={onOverlapModalClose}>
                            Cancel
                          </Button>
                          <Button colorScheme="purple" onClick={handleContinueDespiteOverlap} isLoading={checkoutLoading}>
                            Continue Anyway
                          </Button>
                        </ModalFooter>
                      </ModalContent>
            </Modal>

            {/* ================================================= */}
            {/* RIGHT */}
            {/* ================================================= */}

            <Box
              position={{ base: "static", lg: "sticky" }}
              top="100px"
            >

              <VStack spacing={6} align="stretch">

                {/* ================= ORDER SUMMARY ================= */}

                <Box
                  bg={cardBg}
                  rounded="2xl"
                  border="1px solid"
                  borderColor={borderColor}
                  overflow="hidden"
                >

                  <Box
                    height="6px"
                    bg={`${resolvedTheme}.500`}
                  />

                  <Box p={6}>

                    <Heading size="md" mb={6}>
                      Order Summary
                    </Heading>

                    <VStack spacing={4} align="stretch">

                      <Flex justify="space-between" gap={4}>
                        <Text fontWeight="medium">
                          {offerDetails?.name}
                        </Text>

                        <Text fontWeight="semibold">
                          {offerDetails?.currency}{" "}
                          {offerDetails?.total_price}
                        </Text>

                      </Flex>
                      {GST_REGISTERED && (
                          <Text
                            fontSize="sm"
                            color={mutedText}
                            mt={1}
                          >
                            Price includes GST
                          </Text>
                        )}

                      {offerDetails?.duration_label && (

                        <Flex justify="space-between">

                          <Text color="gray.500">
                            Access Duration
                          </Text>

                          <Box
                            px={3}
                            py={1}
                            borderRadius="full"
                            bg={durationBg}
                            fontSize="xs"
                          >
                            {offerDetails.duration_label}
                          </Box>

                        </Flex>

                      )}

                      <Divider />

                      <Flex justify="space-between">

                        <Heading size="sm">
                          Total
                        </Heading>

                        <Heading size="sm">
                          {offerDetails?.currency}{" "}
                          {offerDetails?.total_price}
                        </Heading>

                      </Flex>

                    </VStack>

                  </Box>

                </Box>

                {/* ================= PAYMENT ================= */}
                <Box
                  bg={cardBg}
                  rounded="2xl"
                  border="1px solid"
                  borderColor={borderColor}
                  p={6}
                >
                  <VStack spacing={5} align="stretch">
                    <Heading size="md">
                      {isFreeOffer ? "Activate Access" : "Payment"}
                    </Heading>

                    {!isFreeOffer && offerDetails && (
                      <Box
                        bg={summaryBg}
                        borderRadius="xl"
                        p={5}
                        border="1px solid"
                        borderColor={borderColor}
                      >
                        <VStack spacing={3} align="stretch">

                          {/* Order summary */}
                          <HStack justify="space-between">
                            <Text fontSize="sm" color={mutedText}>Product</Text>
                            <Text fontSize="sm" fontWeight="semibold">
                              {offerDetails.name}
                            </Text>
                          </HStack>

                          {offerDetails.duration_label && (
                            <HStack justify="space-between">
                              <Text fontSize="sm" color={mutedText}>Access Duration</Text>
                              <Text fontSize="sm">{offerDetails.duration_label}</Text>
                            </HStack>
                          )}

                          <Divider />

                          <HStack justify="space-between">
                            <Text fontWeight="bold">Total</Text>
                            <Text fontWeight="bold" fontSize="lg" color="green.500">
                              {offerDetails.currency} {Number(offerDetails.total_price).toFixed(2)}
                            </Text>
                          </HStack>

                          <Box
                            bg={secureBg}
                            borderRadius="md"
                            p={3}
                          >
                            <HStack spacing={2}>
                              <Icon as={FaLock} color="blue.500" boxSize={3} />
                              <Text fontSize="xs" color={secureText}>
                                You will be redirected to Stripe's secure payment page.
                                We do not store your card details.
                              </Text>
                            </HStack>
                          </Box>
                        </VStack>
                      </Box>
                    )}

                    {isFreeOffer && (
                      <Box
                        bg={freeBg}
                        borderRadius="xl"
                        p={4}
                        border="1px solid"
                        borderColor={freeBorder}
                      >
                        <HStack spacing={3}>
                          <Icon as={FaCheckCircle} color="green.500" boxSize={5} />
                          <VStack align="start" spacing={0}>
                            <Text fontWeight="semibold" fontSize="sm">Free Access</Text>
                            <Text fontSize="xs" color={mutedText}>
                              No payment required — activate instantly.
                            </Text>
                          </VStack>
                        </HStack>
                      </Box>
                    )}

                    {!isFreeOffer && (
                      <Box>
                        <HStack>
                          <Input
                            placeholder="Coupon code"
                            size="sm"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                            bg={inputBg}
                          />
                          <Button size="sm" onClick={handleApplyCoupon} isLoading={couponLoading}>
                            Apply
                          </Button>
                        </HStack>
                        {couponResult?.valid && (
                          <Text fontSize="sm" color="green.500" mt={1}>
                            {couponResult.message} — New total: {offerDetails?.currency} {couponResult.final_amount?.toFixed(2)}
                          </Text>
                        )}
                      </Box>
                    )}

                    <Checkbox
                      isChecked={acceptTerms}
                      onChange={(e) => setAcceptTerms(e.target.checked)}
                    >
                      <Text fontSize="sm">
                        I have read and agree to the{" "}
                        <Link
                          color="blue.500"
                          href="/practice/terms"
                          isExternal
                        >
                          terms and conditions
                        </Link>
                        .
                      </Text>
                    </Checkbox>

                   <Button
                      size="lg"
                      colorScheme={resolvedTheme}
                      isLoading={checkoutLoading}
                      loadingText={payButtonLoadingText}
                      isDisabled={!acceptTerms || registerLoading}
                      onClick={handleBuyNow}
                      leftIcon={isFreeOffer ? <FaCheckCircle /> : <FaLock />}
                    >
                      {payButtonLabel}
                    </Button>

                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => navigate(`/practice/${domainSlug}/${offerSlug}`)}
                    >
                      ← Back to Offer
                    </Button>
                  </VStack>
                </Box>

              </VStack>

            </Box>

          </Grid>

        </Box>

      </Box>

    </PublicLayout>

  );
};

export default B2CCheckoutPage;